//export const Url="https://mirx.com.ar/ecommerce/";
export const Url="https://mirx.com.ar/daira/";
